import { IGetClienteArquivoByIdUseCase } from "../../../presentation/useCases/read/get_cliente_arquivo_by_id_use_case";
import { ClienteArquivo } from "../../models/clienteArquivo";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * GetClienteArquivoByIdUseCase
 */

export class GetClienteArquivoByIdUseCase implements IGetClienteArquivoByIdUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(idClienteArquivo: number): Promise<ClienteArquivo> {
    return this.repository.getClienteArquivoById(idClienteArquivo);

  }
}
